import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { FiltersModel } from '../types/FiltersModel';
import { GamesRequestParams } from '../types/GamesRequestParams';
import GamesAPI from '../api/GamesAPI';

export type FiltersStateType = {
  filters: FiltersModel | null;
  error?: string;
  loading: boolean;
};

export const FiltersInitialState: FiltersStateType = {
  filters: null,
  loading: false,
};

export const getFilters = createAsyncThunk(
  'getFilters',
  async (params: GamesRequestParams, { rejectWithValue, fulfillWithValue }) => {
    try {
      const data = await GamesAPI.getFilters(params);
      return fulfillWithValue(data);
    } catch (error) {
      throw rejectWithValue(error.message);
    }
  }
);

const slice = createSlice({
  name: 'Filters',
  initialState: FiltersInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getFilters.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getFilters.fulfilled, (state, action) => {
      state.loading = false;
      state.filters = action.payload;
    });
    builder.addCase(getFilters.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
  },
});

export default slice.reducer;
